// @flow
import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { SPMLDMutationsContext } from '@streaming-projects/orgs/org-top-level/sp-custom-discounts/contexts/SPMLDMutationsContext';
import { SPOrgContext } from '@streaming-projects/orgs/contexts/SPOrgContext';
import {
  FieldArrayGridConfigItemContext,
  FieldArrayGridUpdateButton,
} from '@src/formik-utils/FieldArrayGrid';
import {
  DEFAULT_VALUE_FOR_DB_ROW_ID,
  METRICS_LEVEL_DISCOUNTS_DIMENSIONS_CONFIG_MLD_ID_BACKEND_NAME,
  RATE_CARD_BACKEND_NAME,
  ROW_ID,
} from '@src/constants';
import { SPUserCommitDetailsContext } from '@streaming-projects/user-commit-details/contexts/SPUserCommitDetailsContext';
import { getIfRowIsVBD } from '@components/custom-discounts/utils';

export const CommitDimensionsConfigUpdateButtonContainer = () => {
  const { orgId, commitId } = useParams();
  const {
    metricDiscountUpdateMutation: [updateMetricDiscounts],
    metricDiscountCreateMutation: [createMetricDiscounts],
  } = useContext(SPMLDMutationsContext);

  const orgData = useContext(SPOrgContext);
  const commitData = useContext(SPUserCommitDetailsContext);
  const { columnsConfiguration, rowValues } = useContext(FieldArrayGridConfigItemContext);

  const payload = {
    ...rowValues,
    metric_name: rowValues.metricName,
    discount: Number(rowValues.discount),
    rate_card_version: orgData?.org[RATE_CARD_BACKEND_NAME],
    commit_version: commitData?.version,
  };

  const updateFuncParams = {
    orgId,
    commitId,
    metricsDiscountId:
      rowValues[ROW_ID] === DEFAULT_VALUE_FOR_DB_ROW_ID
        ? null
        : rowValues[METRICS_LEVEL_DISCOUNTS_DIMENSIONS_CONFIG_MLD_ID_BACKEND_NAME],
    payload,
  };

  return (
    <FieldArrayGridUpdateButton
      columnsConfig={columnsConfiguration}
      disableUpdateButton={getIfRowIsVBD(rowValues)}
      enableUpdateForFrozenRowsEvenWhenNoEditsAreMade={true}
      errorMessage="There was an error in updating the discount configuration, please contact #cloud-commitment-estimator channel!"
      reloadPageAfterUpdate={true}
      updateFunc={
        rowValues[ROW_ID] === DEFAULT_VALUE_FOR_DB_ROW_ID
          ? createMetricDiscounts
          : updateMetricDiscounts
      }
      updateFuncParams={updateFuncParams}
    />
  );
};
